import { render, staticRenderFns } from "./PCQuickLook.vue?vue&type=template&id=6cc63559&"
import script from "./PCQuickLook.vue?vue&type=script&lang=js&"
export * from "./PCQuickLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc63559')) {
      api.createRecord('6cc63559', component.options)
    } else {
      api.reload('6cc63559', component.options)
    }
    module.hot.accept("./PCQuickLook.vue?vue&type=template&id=6cc63559&", function () {
      api.rerender('6cc63559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/PCQuickLook.vue"
export default component.exports